<template>
  <div class="w-100 grid-container">
    <vt-side-panel :visible="showSidePanel">
      <configuration-sidepanel
        :association-type="ASSOCIATION_TYPE.RESPONSIBILITY.key"
        :show-center-filter="true"
        :sidepanel-title="sidepanelTitle"
        :association="$tc('configuration.modal.responsibility', selectedJobResponsabilities.length)"
        :icon="'far fa-sitemap'"
        :list="allSelectedJobResponsibilities"
        @closeConfigurationSidepanel="showSidePanel = false"
        @update="showJobModal($t('configuration.actions.update'), clickedRow); showSidePanel = false"
      />
    </vt-side-panel>
    <configuration-section-header
      class="my-0"
      :section-icon="'far fa-sitemap'"
      :section-title="$tc('configuration.sections.jobs', 2)"
      :section-subtitle="msgSelectedRows"
      @changedPageSize="changedPageSize($event)"
      @changedMode="changedMode($event)"
    >
      <b-button
        v-testing="'update'"
        v-shortkey="['alt', 'e']"
        v-tooltip="$t('configuration.actions.update')"
        :disabled="selectedRows.length !== 1"
        class="btn__icon btn__icon--primary px-2 py-0"
        variant="link"
        @click="showJobModal($t('configuration.actions.update'), selectedRows[0])"
        @shortkey="showJobModal($t('configuration.actions.update'), selectedRows[0])"
      >
        <i
          class="far fa-edit"
          aria-hidden="true"
        />
      </b-button>
    </configuration-section-header>
    <div class="flex-grow-1">
      <vt-grid
        :autosize-columns="false"
        class="configuration-grid people-jobs-grid"
        :grid-options="gridOptions"
        :row-data="rowData"
        :column-defs="columnDefs"
        :component-code="gridUiComponent"
      />
    </div>
    <modal-wrapper ref="jobModalWrapper">
      <job-modal
        ref="jobModal"
        :action-title="actionTitle"
      />
    </modal-wrapper>
  </div>
</template>

<script>
import ConfigurationSectionHeader from '@/modules/configurationModule/ConfigurationSectionHeader'
import VtGrid from '@/components/VtGrid/VtGrid'
import columnsJobsGrid from '@/modules/configurationModule/detail/peopleManagement/jobs/columnsJobsGrid'
import JobModal from '@/modules/configurationModule/detail/peopleManagement/jobs/JobModal'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import ConfigurationSidepanel from '@/modules/configurationModule/detail/ConfigurationSidepanel'
import JobConfigurationServices from '@/api/resources/configuration/peopleManagement/job/JobConfigurationServices'
import JobResponsibilityConfigurationServices from '@/api/resources/configuration/peopleManagement/job/JobResponsibilityConfigurationServices'
import { ASSOCIATION_TYPE } from '@/api/resources/configuration/peopleManagement/AssociationTypes'
import { uniqBy } from 'lodash'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

export default {
    name: 'PeopleJobsGrid',
    components: {
        ConfigurationSectionHeader,
        VtGrid,
        JobModal,
        ConfigurationSidepanel
    },
    data() {
        return {
            gridUiComponent: 'uicomponent.configuration.global.peopleManagement.jobs',
            showSidePanel: false,
            sidepanelTitle: null,
            actionTitle: null,
            selectedRows: [],
            columnDefs: columnsJobsGrid(),
            rowData: [],
            mode: {
                size: 25
            },
            clickedRow: null,
            selectedJobResponsabilities: [],
            allSelectedJobResponsibilities: []
        }
    },
    computed: {
        msgSelectedRows() {
            return this.selectedRows.length > 0 ? `${this.selectedRows.length} ${this.$tc('global.selectedElements', this.selectedRows.length)}` : ''
        },
        rowHeight() {
            return this.mode?.size
        },
        gridOptions() {
            return {
                sideBar: gridSideBarConfig,
                rowModelType: AgGridRowModelType.CLIENT_SIDE,
                paginationPageSize: 20,
                paginationAutoPageSize: false,
                onRowClicked: this.onRowClicked,
                getRowHeight: () => this.rowHeight,
                getContextMenuItems: this.getContextMenuItems,
                onGridReady: this.onGridReady,
                onSelectionChanged: this.onSelectionChanged
            }
        },
        ASSOCIATION_TYPE() {
            return ASSOCIATION_TYPE
        }
    },
    async created() {
        await this.reloadData()
    },
    methods: {
        async reloadData() {
            this.updateLoading(true)
            const [err, data] = await this.toCall(JobConfigurationServices.getJobs())
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.rowData = data
        },
        async onRowClicked(params) {
            this.updateLoading(true)
            const [err, response] = await this.toCall(JobResponsibilityConfigurationServices.getJobResponsibilitiesByJobCode(params?.node.data.code))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.clickedRow = params?.node.data
            this.selectedJobResponsabilities = uniqBy(response, 'responsibility.id').map(item => item['responsibility'])
            this.allSelectedJobResponsibilities = response
            this.showSidePanel = true
            this.sidepanelTitle = params?.node.data.translatedName
        },
        getContextMenuItems(params) {
            if (!params?.node) {
                return []
            } else {
                return [
                    {
                        name: this.$t('configuration.actions.update'),
                        cssClasses: this.selectedRows.length > 1 ? ['not-show'] : '',
                        action: () => this.showJobModal(this.$t('configuration.actions.update'), params?.node.data)
                    }
                ]
            }
        },
        changedPageSize(pageSize) {
            this.gridApi.paginationSetPageSize(pageSize)
        },
        changedMode(selectedOption) {
            this.mode = selectedOption
            this.reloadData()
        },
        onSelectionChanged({ api }) {
            this.selectedRows = api.getSelectedRows()
        },
        onGridReady({ api }) {
            this.gridApi = api
        },
        showJobModal(title, selectedJob) {
            this.actionTitle = selectedJob.translatedName
            this.$refs.jobModalWrapper.show([selectedJob])
        }
    }
}
</script>
